"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useThemeDetector = useThemeDetector;
exports.default = void 0;

var _react = require("react");

function useThemeDetector() {
  const getCurrentTheme = () => {
    var _window, _window$matchMedia;

    return (_window = window) === null || _window === void 0 ? void 0 : (_window$matchMedia = _window.matchMedia('(prefers-color-scheme: dark)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches;
  };

  const [isDarkTheme, setIsDarkTheme] = (0, _react.useState)(getCurrentTheme());

  const mqListener = e => {
    setIsDarkTheme(e.matches);
  };

  (0, _react.useEffect)(() => {
    var _window2;

    const darkThemeMq = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.matchMedia('(prefers-color-scheme: dark)');

    if (darkThemeMq) {
      darkThemeMq === null || darkThemeMq === void 0 ? void 0 : darkThemeMq.addEventListener('change', mqListener);
    }

    return () => darkThemeMq === null || darkThemeMq === void 0 ? void 0 : darkThemeMq.removeEventListener('change', mqListener);
  }, []);
  return isDarkTheme ? 'dark' : 'light';
}

var _default = useThemeDetector;
exports.default = _default;
//# sourceMappingURL=useThemeDetector.js.map